<div class="div_categories">
    <div class="pos-title-header">
        <label class="lbl_top">{{'CATEGORY.CATEGORIES' | translate}}</label>
        <button class="create_btn" (click)="addCategory()">
           <span class="hide_mobile">{{'ADD' | translate}}</span>
           <i class="show_mobile pi pi-plus-circle"></i>
          </button>
    </div>
    <div class="pos-description-header">
      <label>{{'CATEGORY.ADD_CATEGORIES_MESSAGE' | translate}}</label>
    </div>
    <div class="cards_div_wrapper">
      <p-progressSpinner class="w-100 text-center pos_spiner" *ngIf="spinner"></p-progressSpinner>
        <div *ngFor="let category of listAllCategories" class="div_card_category">
            <div>
                <img class="ctg_image" [src]="determineImageUrl(category.pictureURL)">
                <div class="items_dropdown_helper pe-0 pt-0" #icon (click)="menu.toggle($event)"></div>
                <i class="pi pi-ellipsis-v spam_menu_ctg pe-0 pt-0" (click)="icon.click()"></i>
                <p-menu #menu class="edit-menu header-menu" [popup]="true" [model]="items[category.id]"></p-menu>
            </div>
          <div class="div_ctg_lbl">
            <div class="d-flex justify-content-center ms-4">
              <label class=" ctg_lbl" title="{{category.name}}">{{category.name}}</label>
            </div>
            <div class="d-flex justify-content-center">
              <label class=" ctg_lbl" title="{{category.description}}">{{category.description}}</label>
            </div>
          </div>

        </div>
    </div>
</div>
